// src/components/NotificationsPortal.jsx
import React from "react";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

/**
 * notify("success", "Guardado ok")
 * notify("error", "Hubo un error")
 * notify({ type:"success", title:"Perfil", message:"Actualizado", duration:4000 })
 */
export function notify(arg1, arg2, arg3 = {}) {
  let type, title, message, duration, props;

  if (typeof arg1 === "string") {
    type = arg1; // "success" | "error" | "warning" | "info"
    message = arg2;
    props = arg3 || {};
  } else {
    ({ type = "info", title, message, duration, ...props } = arg1 || {});
  }

  const common = {
    autoClose: duration ?? 3500,
    // Si pasas `title`, saldrá arriba y `message` como cuerpo
    render: title ? (
      <div style={{ display: "grid", gap: 4 }}>
        <div style={{ fontWeight: 700 }}>{title}</div>
        {message ? <div style={{ opacity: 0.9 }}>{message}</div> : null}
      </div>
    ) : (
      message
    ),
    ...props,
  };

  // Palomita simple (sin círculo) para SUCCESS
  const successIcon = (
    <svg
      width="22"
      height="22"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M20 6L9 17l-5-5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  switch (type) {
    case "success":
      return toast.success(common.render, {
        ...common,
        icon: successIcon,
      });
    case "error":
      return toast.error(common.render, common);
    case "warning":
      return toast.warn(common.render, common);
    case "info":
    default:
      return toast.info(common.render, common);
  }
}

export default function NotificationsPortal() {
  return (
    <ToastContainer
      // ✅ como lo tenías: esquina superior derecha
      position="top-right"
      autoClose={3500}
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
      theme="light" // clave para que NO pinte el toast completo (lo controlamos con CSS)
      transition={Slide}
      // ✅ quita la barra/progreso que te deja “verde abajo”
      hideProgressBar
      // ✅ deja espacio “tipo banner” y bordes redondeados
      toastStyle={{
        fontFamily: "Inter, sans-serif",
        borderRadius: "18px",
        padding: "18px 18px",
        minHeight: "72px",
      }}
    />
  );
}
